import script from "./OverviewCardMixin.vue?vue&type=script&lang=ts"
export * from "./OverviewCardMixin.vue?vue&type=script&lang=ts"

export default script